import './checkInfoBox.scss';
interface IProps {
	title: string;
	description?: string | string[];
	descriptionType?: 'paragraph' | 'paragraphs' | 'list';
	boxType?: 'box' | 'accordion'; 
}
const CheckInfoBox = ({title, description, descriptionType = 'paragraph'}: IProps) => {
	if (Array.isArray(description) && descriptionType === 'paragraph') descriptionType = 'paragraphs';
	return (
		<div className="check-info-wrap">
			<h4 className="check-info-title">
				<i className="icon icon-checkmark-p500"></i>
				{title}
			</h4>
			<div className="check-info-content">
			{descriptionType === 'paragraph' && <p style={{whiteSpace: 'pre-line'}}>{description}</p>}
			{descriptionType === 'paragraphs' && (description as string[]).map((desc, i) => <p key={`check-info-${desc}-${i}`}>{desc}</p>)}
			{descriptionType === 'list' && <ul>{(description as string[]).map((desc, i) => <li key={`check-info-${desc}-${i}`}>{desc}</li>)}</ul>}
			</div>
		</div>
	);
};

export default CheckInfoBox;